"use client";

import { useSyncExternalStore } from "react";
import { getState, subscribe } from "@/shared/auth/session-controller";
import type { NetworkStatus, SessionStatus } from "@/shared/auth/types";

const getStatus = () => getState().status;
const getNetwork = () => getState().networkStatus;
const getUserId = () => getState().userId;

export function useSessionStatus(): SessionStatus {
  return useSyncExternalStore(subscribe, getStatus, getStatus);
}

export function useNetworkStatus(): NetworkStatus {
  return useSyncExternalStore(subscribe, getNetwork, getNetwork);
}

export function useUserId(): string | null {
  return useSyncExternalStore(subscribe, getUserId, getUserId);
}
